export const SENTRY_DSN =
  'https://a3525a13cacfa0f5420038fe7678681a@o4508908681232384.ingest.de.sentry.io/4510555796930640'

const envGtag = import.meta.env.VITE_GTAG
export const ANALITICS_ID = typeof envGtag === 'string' ? envGtag : 'G-XXXXXXXXXX'
